import {
  CLUB_SIGNUP_REQUEST,
  CREATE_CLUB_SIGNUP_BY_SLUG_REQUEST,
  CREATE_CLUB_SIGNUP_REQUEST,
  EDIT_CLUB_SIGNUP_VIRTUAL_REQUEST,
  GET_CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET,
  GET_CLUB_SIGNUP_FOR_SHARING_REQUEST,
  MOBILE_CLUB_SIGNUP_SUMMARY_NOT_VISIBLE,
  MOBILE_CLUB_SIGNUP_SUMMARY_VISIBLE,
  PROCESS_CLUB_SIGN_UP_REQUEST,
  PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUEST,
  PROCESS_PAY_STACK_CLUB_SIGN_UP_REQUEST,
  UPDATE_CLUB_SIGNUP_REQUEST
} from './constants';

export const authenticateFullSteamWallet = (onSuccess, onError) => ({
  type: GET_CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET,
  onSuccess,
  onError
});

export const processClubSignupForFullSteamWallet = (
  clubSignupId,
  payload,
  onSuccess,
  onError
) => ({
  type: PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUEST,
  clubSignupId,
  payload,
  onSuccess,
  onError
});

export const showMobileSummary = () => ({
  type: MOBILE_CLUB_SIGNUP_SUMMARY_VISIBLE
});

export const hideMobileSummary = () => ({
  type: MOBILE_CLUB_SIGNUP_SUMMARY_NOT_VISIBLE
});

export const createClubSignup = (club, onSuccess) => ({
  type: CREATE_CLUB_SIGNUP_REQUEST,
  club,
  onSuccess
});

export const createClubSignupBySlug = (slug, onSuccess) => ({
  type: CREATE_CLUB_SIGNUP_BY_SLUG_REQUEST,
  slug,
  onSuccess
});

export const getClubSignup = () => ({ type: CLUB_SIGNUP_REQUEST });

export const getForSharing = (id, onSuccess) => ({
  id,
  type: GET_CLUB_SIGNUP_FOR_SHARING_REQUEST,
  onSuccess
});

export const editVirtualSignUp = (payload) => ({
  type: EDIT_CLUB_SIGNUP_VIRTUAL_REQUEST,
  payload
});

export const updateClubSignup = (clubSignup, onSuccess, onError) => ({
  type: UPDATE_CLUB_SIGNUP_REQUEST,
  clubSignup,
  onSuccess,
  onError
});

export const processClubSignup = (payload, onSuccess, onError) => ({
  payload,
  type: PROCESS_CLUB_SIGN_UP_REQUEST,
  onSuccess,
  onError
});

export const processPaystack = (tenderId, onSuccess, onError) => ({
  type: PROCESS_PAY_STACK_CLUB_SIGN_UP_REQUEST,
  tenderId,
  onSuccess,
  onError
});
